import axios from 'axios';
import Cookies from 'js-cookie';
import Cookie from '../../const/Cookie';
import LocalStorage from '../../const/LocalStorage';

export function refreshToken() {
  const REFRESH_TOKEN_URI = '/platform-session/api/v1/authenticate/refreshToken';

  return new Promise((resolve, reject) => {
    convertCookieAdtoLocalStorage();
    let headers = {};
    const adLoginCallcenterStorage = localStorage.getItem(LocalStorage.AD_LOGIN_CALLCENTER);
    const adLoginCallcenter = adLoginCallcenterStorage ? JSON.parse(adLoginCallcenterStorage) : null;

    if (adLoginCallcenter) {
      headers = {
        Authorization: adLoginCallcenter.accessToken ? `Bearer ${adLoginCallcenter.accessToken}` : null,
        adlogin: adLoginCallcenter.adLogin
      }
    }

    unsignedCustomerPortal()
      .then(() => {
        axios
          .get(REFRESH_TOKEN_URI, {
            headers: headers
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(reject);
      }).catch(reject);
  });
}

function unsignedCustomerPortal() {
  const LOGOUT_CUSTOMER_PORTAL = '/platform-session/api/v1/logout/';
  return new Promise((resolve, reject) => {
    if (Cookies.get(Cookie.LOGIN_DATA_KEY)) {
      axios
        .delete(LOGOUT_CUSTOMER_PORTAL, {
          headers: new Headers({
            'Content-Type': 'application/json'
          }),
          withCredentials: true
        })
        .then(response => {
          Cookies.remove(Cookie.LOGIN_DATA_KEY, { path: '/' });
          resolve(response);
        })
        .catch(reject);
    } else {
      resolve(true);
    }
  });
}

function convertCookieAdtoLocalStorage() {
  const cookieAd = Cookies.get(Cookie.AD_LOGIN_CALLCENTER);

  if (cookieAd) {
    localStorage.setItem(LocalStorage.AD_LOGIN_CALLCENTER, cookieAd);
    Cookies.remove(Cookie.AD_LOGIN_CALLCENTER, { path: '' });
  }
}



// WEBPACK FOOTER //
// ./src/services/refreshToken/RefreshTokenService.js